import React from 'react';
import { RedirectToSignIn, SignedIn, SignedOut } from '@clerk/clerk-react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';

export default function ProtectedRoute({ children, allowedRoles = [] }) {
    const location = useLocation();
    const { user } = useUser();
    const redirectUrl = `${location.pathname}${location.search}${location.hash}`;
    const role = String(user?.publicMetadata?.role || '').trim().toLowerCase();
    const hasRoleAccess =
        allowedRoles.length === 0 ||
        allowedRoles.map((item) => String(item).trim().toLowerCase()).includes(role);

    return (
        <>
            <SignedIn>
                {hasRoleAccess ? children : <Navigate to="/" replace />}
            </SignedIn>
            <SignedOut>
                <RedirectToSignIn redirectUrl={redirectUrl} />
            </SignedOut>
        </>
    );
}